








































































































import { Component, Vue } from 'vue-property-decorator';
import { MetaInfo } from 'vue-meta/types/vue-meta';
import TitleContainer from '@/components/common/TitleContainer.vue';
import BlogStore, { BlogStoreInterface } from '@/resource/blog/blog.store';
import BlogItem from '@/components/blogs/BlogItem.vue';
import BlogSearch from '@/components/blogs/BlogSearch.vue';
import BlogLoading from '@/components/blogs/BlogLoading.vue';
import BlogHighlightLoading from '@/components/blogs/BlogHighlightLoading.vue';
import Divider from '@/components/common/Divider.vue';
import Adsense from '@/main-components/adsense/Adsense.vue';
import { pageSEO } from '@/utils/seo';
import seoDefault from '@/utils/seo-default';

@Component({
  components: {
    TitleContainer,
    BlogItem,
    BlogSearch,
    BlogLoading,
    BlogHighlightLoading,
    Divider,
    Adsense,
  },
  metaInfo(this: Blogs): MetaInfo {
    return {
      title: pageSEO.title.blog,
      link: [
        {
          vmid: 'canonical',
          rel: 'canonical',
          href: pageSEO.canonical.blog,
        },
      ],
      meta: [
        ...seoDefault({
          title: pageSEO.titleMeta.blog,
          description: pageSEO.description.blog,
        }),
      ],
    };
  },
})
export default class Blogs extends Vue {
  blogStore: BlogStoreInterface = BlogStore;

  mainTitle = [
    {
      type: 'highlight',
      value: 'Terokai',
    },
    {
      type: 'normal',
      value: 'blog kami',
    },
  ];

  mainP = `Teroka dan baca berita atau artikel terkini untuk mendapatkan petua dan teknik berkaitan pengajaran, cara menggunakan Mysoalan, atau apa sahaja yang berkaitan dengan pendidikan.`;

  get blogs() {
    return this.blogStore.blogs;
  }

  get TophighLightBlog() {
    return this.blogStore.highLightBlogs[0];
  }

  get highLightBlogs() {
    return this.blogStore.highLightBlogs.slice(1, 5);
  }

  get defaultblogs() {
    return this.blogStore.defaultblogs.slice(0, 3);
  }

  get isLastPage() {
    const { pagination } = this.blogStore;
    return pagination.page >= pagination.totalPages;
  }

  isLoading = true;
  isLoadingBlogs = false;
  isLoadingMore = false;
  keyword = '';
  noHighlight = false;

  async created() {
    await this.fetchBlogs();
    this.isLoading = false;
  }

  async fetchBlogs() {
    this.blogStore.pagination.page = 1;
    this.blogStore.pagination.isResetPage = true;

    await this.blogStore.fetchBlogs({ keyword: this.keyword });
    await this.blogStore.fetchHighlightBlogs();

    if (this.blogStore.highLightBlogs.length < 5) {
      this.noHighlight = true;
    }
  }

  async refetchBlogs(keywordInput: string) {
    if (this.isLoading || this.isLoadingBlogs || this.isLoadingMore) return;

    this.isLoadingBlogs = true;
    this.keyword = keywordInput;

    this.blogStore.pagination.page = 1;
    this.blogStore.pagination.isResetPage = true;

    await this.blogStore.fetchBlogs({ keyword: this.keyword });

    this.isLoadingBlogs = false;
  }

  async fetchMore() {
    this.$sendMpEvent({ event: this.$mp_value.BlogLoadMore });

    if (this.isLoading || this.isLoadingBlogs || this.isLoadingMore) return;

    this.isLoadingMore = true;

    this.blogStore.pagination.page += 1;

    await this.blogStore.fetchBlogs({ keyword: this.keyword });

    this.isLoadingMore = false;
  }
}
